import { PrimaryButton } from 'office-ui-fabric-react/lib/Button'
import * as React from 'react'

import { LocalizationService } from '../../localization/LocalizationService'
import * as css from './consentBanner.css'
import { Props } from './props'

export class ConsentBanner extends React.PureComponent<Props> {
  render (): JSX.Element | null {
    if (this.props.showConsentBanner) {
      return (
        <div className={ css.consentBanner }>
          <div className={ css.consentBannerText }>
            <div className={ css.consentBannerHeading }>
              { LocalizationService.getLocalizedString('stickyNotes.consentBannerHeading') }
            </div>
            { LocalizationService.getLocalizedString('stickyNotes.consentBanner') }
          </div>
          <div className={ css.consentBannerButton }>
            <PrimaryButton
              text={ LocalizationService.getLocalizedString('stickyNotes.consentBannerOkay') }
              onClick={ this.props.hideConsentBanner } />
          </div>
        </div>
      )
    } else {
      return null
    }
  }
}
